<template lang="pug">
  div
    v-card
      div.d-flex.pl-6.pr-3.align-center.justify-between.card-header
        h3 Subchapters
        div.d-flex.items-center.justify-end.flex-grow-1
          LicenseTypesFilter(
            :loading="listLoading"
            @filterChanged="onFilterChanged"
          )
          v-btn(fab color="primary" @click="showChapterModal" small)
            v-icon(small) $vuetify.icons.plus
      v-divider
      div.body.no-footer.inner-scroll(style="position: relative;")
        chapter-list(
          :loading="listLoading"
          :list="list"
          :pagination="pagination"
          @addItemToChapter="addItemToChapter"
          @removeItemFromChapter="removeItemFromChapter"
          @updateChapter="updateChapter"
          @onEditClick="editChapter"
          @loadMoreClick="loadListMore"
        )
        div.loader-absolute(v-if="list && list.length && listLoading")
          v-progress-circular(indeterminate size=64 color="warning")
    add-modal(
      :value="chapterModalVisible"
      @input="hideChapterModal"
      @closeModal="hideChapterModal"
      @itemCreated="onChapterCreate"
      @itemUpdated="onChapterUpdate"
      @itemDeleted="onChapterDelete"
      :itemModel="chapterModel"
      :editMode="editMode"
    )
</template>
<script>
import ChapterSvc from "@/app/exercise/modules/trainings/core/chapter-service"
import ErrorMixin from "@/mixins/errors.mixin"
import FormErrors from "@/util/form-errors"
import {showSnackbar} from "@/util"
import EventBus from "@/util/event-bus"
import {LIST_EVENTS} from "@/const/list-events.enum";
import LicenseTypesFilter from "@/app/exercise/modules/trainings/components/LicenseTypesFilter.vue";
export default {
  components: {
    LicenseTypesFilter,
    chapterList: () => import("./ChapterList.vue"),
    addModal: () => import("./ChapterModalAdd.vue"),
  },
  data: () => ({
    svc: null,
    list: [],
    listLoading: false,
    chapterModalVisible: false,
    chapterModel: null,
    editMode: false,
    editItemIndex: null,
    formErrors: null,
    pagination: null,
    filtersQuery: {},
  }),

  mixins: [ErrorMixin],

  created() {
    this.init()
  },

  async mounted() {
    this.loadData()
  },
  
  beforeDestroy() {
    EventBus.$off(LIST_EVENTS.UPDATE_CHAPTER, this.updateChapterKeys)
  },

  methods: {
    init() {
      this.svc = new ChapterSvc(this.$auth)
      this.formErrors = new FormErrors()
      EventBus.$on(LIST_EVENTS.UPDATE_CHAPTER, this.updateChapterKeys)
    },
    
    async loadData() {
      await this.loadList();
      await this.loadChapterCategories();
    },

    async loadChapterCategories() {
      await this.$store.dispatch(`chapterCategories/list`)
    },

    onFilterChanged(filtersObj) {
      this.filtersQuery = {...filtersObj}
      this.loadList();
    },

    async loadList() {
      try {
        this.listLoading = true
        let { results, pagination } = await this.svc.list(this.filtersQuery)
        this.pagination = pagination
        this.list = results
        this.listLoading = false
      } catch (error) {
        this.listLoading = false
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
    },

    async loadListMore(page) {
      try {
        this.listLoading = true
        let { results } = await this.svc.list({
          page,
          ...this.filtersQuery
        })
        this.list.push(...results)
        this.listLoading = false
      } catch (error) {
        this.listLoading = false
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
    },

    async addItemToChapter(chapter, item, questionType, index = null) {
      const originItem = {...item};
      originItem.layout = Array.isArray(this.$route.query.layout ) ? this.$route.query.layout[0] : this.$route.query.layout;
      const licenseTypeMatch = (item.is_auto && chapter.is_auto) || (chapter.is_motor && item.is_motor) || (chapter.is_scooter && item.is_scooter);
      if (!licenseTypeMatch) {
        this.$notify({text: 'License type mismatch', type: 'error'})
        return;
      }
      const isDuplicate = chapter.addItem(originItem, questionType, index);
      if (isDuplicate) {
        showSnackbar('Duplicate item', {color: 'error'})
      } else {
        await this.svc.put(chapter.id, chapter);
        EventBus.$emit(LIST_EVENTS.UPDATE_LIST);
      }
    },

    async removeItemFromChapter(chapter, item, questionType) {
      chapter.removeItem(item, questionType);
      await this.svc.put(chapter.id, chapter);
      EventBus.$emit(LIST_EVENTS.UPDATE_LIST);
    },

    async updateChapter(chapter) {
      await this.svc.put(chapter.id, chapter);
      EventBus.$emit(LIST_EVENTS.UPDATE_LIST);
    },

    async redirectToChapter(chapter) {
      const res = await this.svc.getLink(chapter.id);
      const link = `${process.env.VUE_APP_EXERCISE_URL}exercises/${res.id}`;
      window.location = link;
    },

    editChapter(chapter, index) {
      this.showChapterModal();
      this.chapterModel = chapter;
      this.editMode = true;
      this.editItemIndex = index;
    },

    hideChapterModal() {
      this.chapterModalVisible = false;
      this.resetModalData();
    },

    resetModalData() {
      this.editMode = false;
      this.editItemIndex = null;
      this.chapterModel = {};
    },

    showChapterModal() {
      this.chapterModalVisible = true
    },

    onChapterCreate() {
      this.loadList();
    },

    onChapterUpdate() {
      this.loadList();
    },

    onChapterDelete() {
      this.list.splice(this.editItemIndex, 1)
    },

    updateChapterKeys({chapter, key}) {
      this.list.forEach( item => {
        if( item.id === chapter.id ) {
          item[key] = chapter[key];
        }
      } );
    },
  },
}
</script>

<style lang="scss" scoped>
.loader-absolute {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba(255,255,255,0.5);
  z-index: 18;
  top: 0;
  left: 0;
}
</style>